import { Input } from "@chakra-ui/react"
import { ContactInputProps } from "@definitions/types"
import { Controller } from "react-hook-form"

const ContactInput = ({
  id,
  placeholder,
  type,
  ...props
}: ContactInputProps) => {
  return (
    <Controller
      {...props}
      render={({ field: { ref, ...restField } }) => (
        <Input
          id={id}
          variant={"flushed"}
          placeholder={placeholder}
          borderColor={"brand.black"}
          focusBorderColor={"brand.primary"}
          fontSize={"2xl"}
          type={type ? type : "text"}
          color={"brand.primary"}
          _placeholder={{ color: "gray.300" }}
          ref={ref}
          {...restField}
        />
      )}
    />
  )
}

export default ContactInput
